module.exports = __webpack_public_path__ + "static/slide2-743x573-f7bdef2fb9f7ac148d21373bd7bc5d2a.gif";